import { LOADING_INDICATOR_CSS_SELECTOR } from '@vfde-sails/constants';
import { disableScrollRestoration } from '../../helpers/disableScrollRestoration';
import { mountChunkingButton } from '../../components/Button';
import { mountTotalDevicesText } from '../../components/JustText';
import { mountLoadingSpinner } from '../../components/LoadingSpinner';
import { mountAccordion } from '../../components/Accordion';
import { mountFilterPill } from '../../components/FilterPill';
import { mountBeltContainers } from '../../components/BeltContainer';
import { mountTextHeader } from '../../components/TextHeader';
import { prepareProductCard } from '../../components/ProductCard';
import {
    ACCORDION_CONTAINER_ID,
    BELT_CONTAINER_CONTAINER_ID,
    ERROR_NOTIFICATION_CONTAINER_ID,
    FILTER_PILL_CONTAINER_ID,
    CHUNKING_BUTTON_CONTAINER_ID,
    PRODUCT_CARD_CONTAINER_ID,
    TEXT_HEADER_CONTAINER_ID,
    TOTAL_DEVICES_CONTAINER_ID,
} from '../../app/constants';
import { useAppDispatch } from '../../app/store';
import { initApp } from './slice';
import { startListeners } from './listeners';

const init = () => {
    disableScrollRestoration();
    startListeners();

    mountLoadingSpinner(LOADING_INDICATOR_CSS_SELECTOR);
    mountTextHeader(TEXT_HEADER_CONTAINER_ID);
    mountBeltContainers(
        BELT_CONTAINER_CONTAINER_ID,
        ERROR_NOTIFICATION_CONTAINER_ID,
    );
    mountFilterPill(FILTER_PILL_CONTAINER_ID);
    mountTotalDevicesText(TOTAL_DEVICES_CONTAINER_ID);
    prepareProductCard(PRODUCT_CARD_CONTAINER_ID);
    mountChunkingButton(CHUNKING_BUTTON_CONTAINER_ID);

    mountAccordion(ACCORDION_CONTAINER_ID);

    const dispatch = useAppDispatch();
    dispatch(initApp());
};

export default init;
